import { CheckBox } from "@/components";
import { useModal } from "@/contexts";
import { TermModalContent } from "@/domains/components";
import { Box, Divider, Flex, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { PRIVACY_INFO_POLICY } from "@shared/client";
import { GuideInfoResponse, useGetGuideInfo } from "@shared/server";
import { useFormContext, useWatch } from "react-hook-form";
import { TermsProps } from "./terms.type";

export const Terms = ({ control }: TermsProps) => {
    const { data } = useGetGuideInfo<GuideInfoResponse>({ section: "guide" });
    const { setModalContent, openModal, setIconName } = useModal();
    const { setValue } = useFormContext();

    const onModal = ({ title, contents }: { title: string; contents: string }) => {
        setModalContent(<TermModalContent title={title} contents={contents}></TermModalContent>);
        setIconName("close");
        openModal();
    };
    const allTerms = ["terms.notice", "terms.refund", "terms.privacy"];
    const checkedStates = useWatch({ control, name: allTerms });

    const handleAllCheck = (checked: boolean) => {
        if (data) {
            allTerms.forEach((name) => setValue(name, checked));
        }

        setValue("terms.privacy", checked);
    };

    return (
        <Flex w={"100%"} flexDir="column" gap={"24px"}>
            <CustomDivider />
            <Box>
                <CheckBox
                    label="전체 동의"
                    name="all"
                    onChange={(e) => handleAllCheck(e.target.checked)}
                    isChecked={checkedStates.every(Boolean)}
                />
            </Box>
            <Flex flexDir={"column"}>
                {data &&
                    data.currentGuide.map((it, index) => {
                        const validateText = it.contents.replace(/nbsp;|amp;|&|<\/?[^br]+(>)/g, "");

                        return (
                            <Flex key={index} flexDir={"column"} position={"relative"} marginBottom="8px">
                                <CheckBox key={it.name} control={control} label={it.title} name={`terms.${it.name}`} />
                                <Box position={"absolute"} right="0">
                                    <Text
                                        cursor={"pointer"}
                                        onClick={() => onModal({ title: it.title, contents: validateText })}
                                    >
                                        보기
                                    </Text>
                                </Box>
                            </Flex>
                        );
                    })}
                {data && (
                    <Flex flexDir={"column"} position={"relative"}>
                        <CheckBox control={control} label="개인정보이용방침" name={`terms.privacy`} />
                        <Box position={"absolute"} zIndex="99" right="0">
                            <Text
                                cursor={"pointer"}
                                onClick={() => onModal({ title: "개인정보 이용 방침", contents: PRIVACY_INFO_POLICY })}
                            >
                                보기
                            </Text>
                        </Box>
                    </Flex>
                )}
            </Flex>
        </Flex>
    );
};

const CustomDivider = styled(Divider)`
    color: ${({ theme }) => theme.COLOR.gray[300]};
`;
